import { compact, pickBy } from 'lodash';
import { ModelEntityType } from '../model/input/types';
import { renderApiProfileUiPath, renderViewUiPath } from './renderer-settings';
import { renderOptionsToQueryStringValue } from './shared';
import { RenderItem, RenderOptions } from './types';

export type Renderer = 'default' | 'api-profile'; // | 'share-image';

export function getRenderViewURL(
  _options: Partial<RenderOptions>,
  sendingUrlToPuppeteer?: boolean,
  renderer?: Renderer,
) {
  const optionsWithFalsyValues: Partial<RenderOptions> = sendingUrlToPuppeteer
    ? { ..._options, showControlUi: false }
    : _options;

  // No need to pass falsy params to the url, so let's just strip them
  const options: Partial<RenderOptions> = removeFalsyRenderViewOptions(optionsWithFalsyValues);

  const baseUrl = renderer == 'api-profile' ? `${renderApiProfileUiPath}` : `${renderViewUiPath}`;
  const url = `${baseUrl}?data=${renderOptionsToQueryStringValue(options)}`;
  return url;
}

// This is compatible with ImpactChartDataSeries
interface WithPossibleIdTypeAndResultId {
  id?: string;
  type?: ModelEntityType;
  resultId?: number;
  name?: string;
  color?: string;
}

export function toRenderViewItems<T extends WithPossibleIdTypeAndResultId>(data: T[]): RenderItem[] {
  const withResultIdAndIndex = compact(
    data.map((d, index): RenderItem | undefined => {
      const { id, type, resultId, name, color } = d;
      if (resultId === undefined || id === undefined || type === undefined) {
        return undefined;
      }
      return { id, resultId, type, index, name, color };
    }),
  );
  return withResultIdAndIndex;
}

export function removeFalsyRenderViewOptions(options: Partial<RenderOptions>) {
  const ret = pickBy(options, option => {
    if (typeof option === 'number') {
      return true;
    }
    if (Array.isArray(option)) {
      return !!option.length;
    }
    return !!option;
  });
  return ret;
}
